import { render, staticRenderFns } from "./index.html?vue&type=template&id=4154842e&scoped=true&external"
import script from "./index.js?vue&type=script&lang=ts&external"
export * from "./index.js?vue&type=script&lang=ts&external"
import style0 from "./index.scss?vue&type=style&index=0&id=4154842e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4154842e",
  null
  
)

export default component.exports